import { ca } from '@cian/analytics';
import { getFormId } from '../../services/formId';

export const getGALabel = (additionals, optionId) => {
  const isHighlight = additionals.find((additional) => additional.id === 'highlight');

  const isAuction = optionId.indexOf('auction') > -1;

  let name = isAuction
    ? optionId.replace('+auction', '')
    : optionId;

  if (isHighlight) {
    name += '+highlight';
  }

  if (isAuction) {
    name += '+auction';
  }

  return name.replace('highlight', 'color').replace(/\+/g, '/');
};

export const trackPayClick = (category) => {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'click_pay_lk',
    label: 'balance',
  });
};

export const trackOptionClick = (optionId, category) => {
  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'publish_terms_block_change_vas',
    label: optionId,
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: getFormId(),
      },
    }
  });
};

